export default "__VITE_PUBLIC_ASSET__7644049d__"